module.exports = __webpack_public_path__ + "static/img/ss4in1-3.ecdd5a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stdfastces/ss4in1-3.jpg
// module id = du3T
// module chunks = 0